import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  imports: [CommonModule],
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  menuItems = [
    { label: 'Inicio', route: 'inicio' },
    { label: 'Beneficios', route: 'beneficios' },
    { label: 'Simulador', route: 'simulador' },
    { label: 'Cómo hacerlo', route: 'como-hacerlo' },
    { label: 'Preguntas frecuentes', route: 'preguntas-frecuentes' },
  ];

  activeFragment: string = 'inicio';

  constructor(private router: Router) {}

  ngOnInit() {
    this.activeFragment = this.router.url.split('#')[1] || 'inicio';
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.activeFragment = this.router.url.split('#')[1] || 'inicio';
    });
  }

  isActive(route: string): boolean {
    return this.activeFragment === route;
  }

  scrollToSection(route: string, event: Event) {
    event.preventDefault();
    const element = document.getElementById(route);
    if (element) {
      const yOffset = -160;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
      this.activeFragment = route;
    }
  }
}
